import React, { useState } from 'react';
import { CompartmentItem, ItemInstance, initializeInstances } from '../types/inventory';
import './ExpiryDialog.css';

interface ExpiryDialogProps {
  item: CompartmentItem;
  onSave: (instances: ItemInstance[]) => void;
  onClose: () => void;
}

const ExpiryDialog: React.FC<ExpiryDialogProps> = ({ item, onSave, onClose }) => {
  const [instances, setInstances] = useState<ItemInstance[]>(
    initializeInstances(item.qty, item.instances)
  );
  const [bulkDate, setBulkDate] = useState<string>('');

  const handleDateChange = (index: number, value: string) => {
    const newInstances = [...instances];
    newInstances[index] = { 
      ...newInstances[index],
      expiryDate: value || null 
    };
    setInstances(newInstances);
  };

  const handleBulkSet = () => {
    if (!bulkDate) return;
    const newInstances = instances.map(inst => ({
      ...inst,
      expiryDate: bulkDate
    }));
    setInstances(newInstances);
  };

  const handleClearAll = () => {
    const newInstances = instances.map(inst => ({
      ...inst,
      expiryDate: null
    }));
    setInstances(newInstances);
  };

  const handleSave = () => {
    onSave(instances);
  };

  const validCount = instances.filter(i => i.expiryDate).length;

  return (
    <div className="expiry-dialog-overlay" onClick={onClose}>
      <div className="expiry-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="expiry-dialog-header">
          <h3>Manage Expiry Dates</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        
        <div className="expiry-dialog-info">
          <strong>{item.name}</strong>
          <p>Total quantity: {item.qty} items ({validCount} with expiry dates set)</p>
        </div>

        <div className="bulk-actions">
          <h4>Quick Actions</h4>
          <div className="bulk-action-row">
            <input 
              type="date"
              value={bulkDate}
              onChange={(e) => setBulkDate(e.target.value)}
              placeholder="Select date"
            />
            <button onClick={handleBulkSet} disabled={!bulkDate}>
              Set All to This Date
            </button>
            <button onClick={handleClearAll} className="clear-btn">
              Clear All Dates
            </button>
          </div>
        </div>

        <div className="expiry-list">
          <h4>Individual Items</h4>
          <div className="expiry-grid">
            {instances.map((instance, index) => (
              <div key={index} className="expiry-row">
                <label>Item #{index + 1}</label>
                <input 
                  type="date"
                  value={instance.expiryDate || ''}
                  onChange={(e) => handleDateChange(index, e.target.value)}
                />
              </div>
            ))}
          </div>
        </div>

        <div className="expiry-dialog-footer">
          <button onClick={onClose} className="cancel-btn">Cancel</button>
          <button onClick={handleSave} className="save-btn">Save Changes</button>
        </div>
      </div>
    </div>
  );
};

export default ExpiryDialog;
